import ConnectivityError from "./ConnectivityError"

export default ConnectivityError
